import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeroProps {
  title: string;
  description: string;
  crumbs: Crumb[];
  icon?: string;
}

export default function PageHero({ title, description, crumbs, icon = "ri-bookmark-3-line" }: PageHeroProps) {
  return (
    <section className="border-b border-background-200 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50">
      <div className="mx-auto max-w-[1280px] px-4 py-8 md:px-8 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 flex items-start gap-4">
          <span className="hidden h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-white sm:flex">
            <i className={`${icon} text-2xl`} />
          </span>
          <div>
            <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">{title}</h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}